import type { HrCase } from '@squadlab/contracts';
import type { CaseRepository } from '../ports/case-repository.js';
import { err, ok } from '../core/result.js';

/**
 * In-memory CaseRepository — the v1 simulation's case store (ADR 0004).
 * Venture-scoped reads; newest cases first. Data lives for the session only —
 * durable persistence is backlog N2.
 */
export function createMemoryCaseRepository(): CaseRepository {
  const byId = new Map<string, HrCase>();

  return {
    async list(ventureId, signal) {
      if (signal.aborted) return err('cancelled', 'Case list was cancelled');
      const cases = [...byId.values()]
        .filter((c) => c.ventureId === ventureId)
        .sort((a, b) => b.openedAt - a.openedAt);
      return ok(cases);
    },

    async get(ventureId, caseId, signal) {
      if (signal.aborted) return err('cancelled', 'Case read was cancelled');
      const hit = byId.get(caseId);
      if (!hit || hit.ventureId !== ventureId) {
        return err('not_found', `No case ${caseId} in venture ${ventureId}`);
      }
      return ok(hit);
    },

    async save(hrCase, signal) {
      if (signal.aborted) return err('cancelled', 'Case save was cancelled');
      byId.set(hrCase.id, hrCase);
      return ok(hrCase);
    },
  };
}
